import React from 'react';
import memoizeOne from 'memoize-one';

interface PathProps {
  d: string;
  fillRule?: 'nonzero' | 'evenodd' | 'inherit';
  clipRule?: 'nonzero' | 'evenodd' | 'inherit';
  id: string;
}

const ICON_PATHS: PathProps[] = [
  {
    id: 'path-1',
    d: 'M23.98 4q.99 0 1.96.1l-.15 1.49-.14 1.49Q24.82 7 24 7a17 17 0 1 0 1.65 33.92l.14 1.5.15 1.48q-.94.1-1.92.1h-.04a20 20 0'
      + ' 0 1 0-40M32.7 40.32l.7 1.32a20 20 0 0 1-3.62 1.5l-.43-1.43-.44-1.44Q30.53 39.8 32 39zM39.44 36.69a20 20 0 0 1-2.77 2.77l'
      + '-1.9-2.32q1.28-1.06 2.35-2.35z',
  },
  {
    id: 'path-2',
    d: 'M23.63 29.19a2.16 2.16 0 1 1 0 4.32 2.16 2.16 0 0 1 0-4.32M41.68 29.37l1.44.44a20 20 0 0 1-1.5 3.62l-1.32-.7-1.33-.72q.78-1.46'
      + ' 1.28-3.07zM22.14 14.77a7 7 0 0 1 2.87-.12 5 5 0 0 1 3.81 3.36c.54 1.7.07 3.48-1.3 4.85-.74.75-1.49 1.14-1.98 1.68l-.02-.01c'
      + '-.44.47-.4.95-.4 1.37a1.5 1.5 0 0 1-3 0v-.23c0-2.35 1.28-3.36 2.21-4.09q.4-.3.8-.68c.72-.73.7-1.45.55-1.92a2 2 0 0 0-1.5-1.38'
      + ' a3.1 3.1 0 0 0-2.66.88 1.5 1.5 0 0 1-2.23-2 6.4 6.4 0 0 1 2.85-1.71M43.88 22.04a20 20 0 0 1 0 3.92l-1.49-.15-1.5-.14a17 17 0 0'
      + ' 0 0-3.34l1.5-.14zM41.62 14.57a20 20 0 0 1 1.5 3.62l-1.44.44-1.43.43q-.5-1.61-1.28-3.07l1.33-.71zM36.67 8.54q1.51 1.25 2.77'
      + ' 2.77l-2.32 1.9q-1.06-1.3-2.36-2.35zM29.78 4.86q1.9.58 3.63 1.5l-.71 1.32L32 9q-1.47-.79-3.09-1.27l.44-1.44z',
  },
];

export const simQuizIcon = memoizeOne((iconClass: string, iconWrapperClass: string, size?: string) => {
  const svgSize = size || '1x';
  return (
    <div className={iconWrapperClass || ''}>
      <svg
        name="simulation-quiz"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        fill="currentColor"
        width="1rem"
        height="1rem"
        className={`o-els-icon-svg--${svgSize} u-els-display-block ${!iconWrapperClass ? 'u-els-margin-top-1o4' : ''} ${iconClass || ''}`}
      >
        {ICON_PATHS.map((path) => (
          <path
            key={path.id}
            d={path.d}
            {...(path.fillRule && { fillRule: path.fillRule })}
            {...(path.clipRule && { clipRule: path.clipRule })}
          />
        ))}
      </svg>
    </div>
  );
});
